export type InventoryMainTab = 'review' | 'expected' | 'variance' | 'history';

/** Shareable tab selection; unknown values keep the page's Count Review default. */
export function readInventoryTab(params: URLSearchParams, canViewExpected = false): InventoryMainTab {
  const tab = params.get('tab');
  if (tab === 'expected' && canViewExpected) return 'expected';
  return tab === 'variance' || tab === 'history' ? tab : 'review';
}

export function withInventoryTab(params: URLSearchParams, tab: InventoryMainTab): URLSearchParams {
  const next = new URLSearchParams(params);
  next.set('tab', tab);
  return next;
}
